"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginMethod = exports.DropDownTypeSelector = exports.EngagementTypeSelector = exports.FeatureTypeSelector = exports.ProgramSelector = exports.SubjectSelector = exports.SubjectTypeSelector = exports.ShadowColor = exports.BackgroundColor = exports.TextColor = exports.Color = void 0;
// =============================== Colors ===============================
var Color;
(function (Color) {
    Color["Black"] = "Black";
    Color["White"] = "White";
    Color["Gray"] = "Gray";
    Color["FashionFuchsia"] = "FashionFuchsia";
    Color["BurntOrange"] = "BurntOrange";
    Color["ElectricUltramarine"] = "ElectricUltramarine";
    Color["RichElectricBlue"] = "RichElectricBlue";
    Color["IslamicGreen"] = "IslamicGreen";
    Color["RossoCorsa"] = "RossoCorsa";
    Color["RedDevil"] = "RedDevil";
})(Color || (Color = {}));
exports.Color = Color;
var TextColor;
(function (TextColor) {
    TextColor["Black"] = "black-text";
    TextColor["White"] = "white-text";
    TextColor["Gray"] = "gray-text";
    TextColor["FashionFuchsia"] = "fashion-fuchsia-text";
    TextColor["BurntOrange"] = "burnt-orange-text";
    TextColor["ElectricUltramarine"] = "electric-ultramarine-text";
    TextColor["RichElectricBlue"] = "rich-electric-blue-text";
    TextColor["IslamicGreen"] = "islamic-green-text";
    TextColor["RossoCorsa"] = "rosso-corsa-text";
    TextColor["RedDevil"] = "red-devil-text";
})(TextColor || (TextColor = {}));
exports.TextColor = TextColor;
var BackgroundColor;
(function (BackgroundColor) {
    BackgroundColor["Black"] = "black-bg";
    BackgroundColor["White"] = "white-bg";
    BackgroundColor["Gray"] = "gray-bg";
    BackgroundColor["FashionFuchsia"] = "fashion-fuchsia-bg";
    BackgroundColor["BurntOrange"] = "burnt-orange-bg";
    BackgroundColor["ElectricUltramarine"] = "electric-ultramarine-bg";
    BackgroundColor["RichElectricBlue"] = "rich-electric-blue-bg";
    BackgroundColor["IslamicGreen"] = "islamic-green-bg";
    BackgroundColor["RossoCorsa"] = "rosso-corsa-bg";
    BackgroundColor["RedDevil"] = "red-devil-bg";
})(BackgroundColor || (BackgroundColor = {}));
exports.BackgroundColor = BackgroundColor;
var ShadowColor;
(function (ShadowColor) {
    ShadowColor["Black"] = "black-shadow";
    ShadowColor["White"] = "white-shadow";
    ShadowColor["Gray"] = "gray-shadow";
    ShadowColor["FashionFuchsia"] = "fashion-fuchsia-shadow";
    ShadowColor["BurntOrange"] = "burnt-orange-shadow";
    ShadowColor["ElectricUltramarine"] = "electric-ultramarine-shadow";
    ShadowColor["RichElectricBlue"] = "rich-electric-blue-shadow";
    ShadowColor["IslamicGreen"] = "islamic-green-shadow";
    ShadowColor["RossoCorsa"] = "rosso-corsa-shadow";
    ShadowColor["RedDevil"] = "red-devil-shadow";
})(ShadowColor || (ShadowColor = {}));
exports.ShadowColor = ShadowColor;
// =============================== SELECTORS ===============================
/* NOTE:
   - Values are camelCase of what would be in JSON
*/
var SubjectTypeSelector;
(function (SubjectTypeSelector) {
    SubjectTypeSelector["FOUNDATION"] = "foundation";
    SubjectTypeSelector["SPECIALTY"] = "specialty";
})(SubjectTypeSelector || (SubjectTypeSelector = {}));
exports.SubjectTypeSelector = SubjectTypeSelector;
// TODO: See if way can auto-populate these Enums based on Subjects Data (since they boil down to JavaScript)
//   ... Subject JSON has a "selector" field which is meant to be EXACTLY the values here
var SubjectSelector;
(function (SubjectSelector) {
    SubjectSelector["FITNESS"] = "fitness";
    SubjectSelector["NUTRITION"] = "nutrition";
    SubjectSelector["MACHINE_LEARNING"] = "machineLearning";
    SubjectSelector["LEARNING"] = "learning";
    // Fundmanetals Section -- TODO: Determine if want keep a part of this Selector
    SubjectSelector["CONCEPTS"] = "concepts";
})(SubjectSelector || (SubjectSelector = {}));
exports.SubjectSelector = SubjectSelector;
// Update this with the name of Program whenever add new one
// KEY should be CAPS SNAKE_CASE, VALUE should be camelCase
var ProgramSelector;
(function (ProgramSelector) {
    ProgramSelector["MUSCLE_UP"] = "muscleUp";
    ProgramSelector["EAT_UP"] = "eatUp";
    ProgramSelector["MACHINE_LEARNING"] = "machineLearning";
    ProgramSelector["EFFECTIVE_LEARNING"] = "effectiveLearning";
    ProgramSelector["SKILL_ACQUISITION"] = "skillAcquisition";
    // TODO: RETHINK -- How will work if have mutl of same name? Similar for "OVERVIEW"
    // ... Won't be unique anymore for Upserts into DB
    ProgramSelector["FUNDAMENTALS"] = "fundamentals";
    // Fundmanetals Section -- TODO: Determine if want keep a part of this Selector
    ProgramSelector["OVERVIEW"] = "overview";
})(ProgramSelector || (ProgramSelector = {}));
exports.ProgramSelector = ProgramSelector;
var FeatureTypeSelector;
(function (FeatureTypeSelector) {
    FeatureTypeSelector["COURSE"] = "course";
    FeatureTypeSelector["DEEP_DIVES"] = "deepDives";
    FeatureTypeSelector["QUIZZES"] = "quizzes";
    FeatureTypeSelector["ACTION_PLAN"] = "actionPlan";
    FeatureTypeSelector["RESOURCES"] = "resources";
    FeatureTypeSelector["COACHING"] = "coaching";
})(FeatureTypeSelector || (FeatureTypeSelector = {}));
exports.FeatureTypeSelector = FeatureTypeSelector;
var EngagementTypeSelector;
(function (EngagementTypeSelector) {
    EngagementTypeSelector["SCHEDULE"] = "schedule";
    EngagementTypeSelector["OFFERS"] = "offers";
    EngagementTypeSelector["PORTFOLIO"] = "portfolio";
    EngagementTypeSelector["TESTIMONIALS"] = "testimonials";
    EngagementTypeSelector["CONTACT"] = "contact";
})(EngagementTypeSelector || (EngagementTypeSelector = {}));
exports.EngagementTypeSelector = EngagementTypeSelector;
var DropDownTypeSelector;
(function (DropDownTypeSelector) {
    DropDownTypeSelector["FOUNDATION"] = "foundation";
    DropDownTypeSelector["COURSES"] = "courses";
    DropDownTypeSelector["COACHING"] = "coaching";
    DropDownTypeSelector["MORE"] = "more";
})(DropDownTypeSelector || (DropDownTypeSelector = {}));
exports.DropDownTypeSelector = DropDownTypeSelector;
// =================================== MISC ====================================
var LoginMethod;
(function (LoginMethod) {
    LoginMethod["GOOGLE"] = "google";
    LoginMethod["FACEBOOK"] = "facebook";
})(LoginMethod || (LoginMethod = {}));
exports.LoginMethod = LoginMethod;
